/**
 * 轮播图API服务
 * 用于获取轮播图数据
 */

import { getApiUrl, API } from './config';

/**
 * 获取首页轮播图数据
 * @returns {Promise} 返回轮播图数据的Promise
 */
export const getBanners = async () => {
  try {
    const response = await fetch(getApiUrl(API.BANNER));
    const data = await response.json();
    
    if (data.code === 1) {
      return data.data;
    } else {
      console.error('获取轮播图失败:', data.msg);
      return [];
    }
  } catch (error) {
    console.error('获取轮播图出错:', error);
    return [];
  }
}; 